import axios from 'axios'
import store from '@/store'
import qs from 'qs'
import {Message} from 'iview'
import {removeToken} from '@/libs/util'

// import { Spin } from 'iview'
// const addErrorLog = errorInfo => {
//   const { statusText, status, request: { responseURL } } = errorInfo
//   let info = {
//     type: 'ajax',
//     code: status,
//     mes: statusText,
//     url: responseURL
//   }
//   if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
// }

class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl
        this.queue = {}
    }

    getInsideConfig() {
        const config = {
            baseURL: this.baseUrl,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            paramsSerializer: function (params) {
                return qs.stringify(params)
            },
            transformRequest: [function (data, headers) {
                return qs.stringify(data)
            }],
            withCredentials: true
        }
        return config
    }

    destroy(url) {
        delete this.queue[url]
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // Spin.show() // 不建议开启，因为界面不友好
            }
            this.queue[url] = true
            return config
        }, error => {
            return Promise.reject(error)
        })
        // 响应拦截
        instance.interceptors.response.use(res => {
            this.destroy(url)
            if (res.data.code == 10001){
                removeToken();
                location.reload();
            }
            const {data, status} = res
            return {data, status}
        }, error => {
            this.destroy(url)
            Message.error(error.message);
            return Promise.reject(error)
        })
    }

    request(options) {
        const instance = axios.create()
        options = Object.assign(this.getInsideConfig(), options)
        this.interceptors(instance, options.url)
        return instance(options)
    }

    get(url, params) {
        return this.request({
            url: url,
            params: params,
            method: 'get'
        }).then(res => res.data).catch(err => {
            return Promise.reject(err)
        });
    }

    post(url, params) {
        return this.request({
            url: url,
            data: params,
            method: 'post'
        }).then(res => res.data).catch(err => {
            return Promise.reject(err)
        });
    }

    // const data = {
    //   userName,
    //   password
    // }
    // return axios.request({
    //                        url: 'login',
    //                        data:data,
    //                        method: 'post'
    //                      })

    // axios.request({
    //                 url: 'get_info',
    //                 params: {
    //                   token
    //                 },
    //                 method: 'get'
    //               })
}

export default HttpRequest
